module.exports = __webpack_public_path__ + "img/5-4.3df4b427.png";